import { Injectable, inject } from '@angular/core';

import { FsApi, RequestConfig } from '@firestitch/api';

import { Observable } from 'rxjs';


// Invites are an organization's under environments/:environmentId/invites, and
// the application's (an admin's) under invites: each method takes the
// organization, or null for the application's.
@Injectable({
  providedIn: 'root',
})
export class InviteData {
  private _api = inject(FsApi);


  public gets(
    environmentId: number | null,
    query: any = {},
    config: RequestConfig = {},
  ): Observable<any> {
    return this._api
      .request('GET', this._getPath(environmentId), query, { key: 'invites', ...config });
  }

  public post(
    environmentId: number | null,
    data: { email: string; objects: any[] },
  ): Observable<any> {
    return this._api.post(this._getPath(environmentId), data, { key: 'invite' });
  }

  public resend(environmentId: number | null, inviteId: number): Observable<any> {
    return this._api
      .post(`${this._getPath(environmentId)}/${inviteId}/resend`, {}, { key: 'invite' });
  }

  public delete(environmentId: number | null, inviteId: number): Observable<any> {
    return this._api.delete(`${this._getPath(environmentId)}/${inviteId}`, {}, { key: 'invite' });
  }

  private _getPath(environmentId: number | null): string {
    return environmentId ? `environments/${environmentId}/invites` : 'invites';
  }
}
